import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ec5277e0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "reward-box"
};
const _hoisted_2 = {
  class: "reward-tit"
};
const _hoisted_3 = {
  class: "reward-info"
};
const _hoisted_4 = {
  class: "info-top-box"
};
const _hoisted_5 = {
  class: "money"
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  class: "limited"
};
const _hoisted_9 = {
  key: 0,
  class: "limited_item"
};
const _hoisted_10 = {
  key: 1,
  class: "limited_item"
};
const _hoisted_11 = {
  key: 2,
  class: "limited_item"
};
const _hoisted_12 = {
  key: 3,
  class: "limited_item"
};
const _hoisted_13 = {
  key: 4,
  class: "limited_item"
};
const _hoisted_14 = {
  key: 5,
  class: "limited_item"
};
const _hoisted_15 = {
  key: 6,
  class: "limited_item"
};
const _hoisted_16 = {
  key: 7,
  class: "limited_item"
};
const _hoisted_17 = {
  key: 8,
  class: "limited_item"
};
const _hoisted_18 = {
  key: 9,
  class: "limited_item"
};
const _hoisted_19 = {
  key: 10,
  class: "limited_item limited_item_related"
};
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 加购档 ");
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1));
const _hoisted_22 = [_hoisted_20, _hoisted_21];
const _hoisted_23 = {
  class: "res"
};
const _hoisted_24 = {
  key: 0,
  class: "icon"
};
const _hoisted_25 = {
  class: "title"
};
const _hoisted_26 = {
  key: 0,
  class: "time"
};
const _hoisted_27 = {
  class: "imgs"
};
const _hoisted_28 = ["src"];
const _hoisted_29 = ["innerHTML"];
const _hoisted_30 = {
  key: 1,
  class: "customized"
};
const _hoisted_31 = {
  key: 2,
  class: "customized"
};
const _hoisted_32 = {
  key: 0,
  class: "info-top-bg"
};
const _hoisted_33 = {
  class: "reward-list-title"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "选择回报", -1));
const _hoisted_35 = {
  class: "reward-list-box"
};
const _hoisted_36 = ["onClick"];
const _hoisted_37 = {
  key: 0
};
const _hoisted_38 = {
  key: 1
};
const _hoisted_39 = {
  key: 2
};
const _hoisted_40 = {
  key: 3
};
const _hoisted_41 = {
  key: 4
};
const _hoisted_42 = {
  key: 5,
  class: "checked-icon",
  src: "https://p.moimg.net/mdwxapp/reward_logo.png"
};
const _hoisted_43 = {
  key: 0,
  class: "reword-list-bg"
};
const _hoisted_44 = {
  class: "reward-btn"
};
const _hoisted_45 = {
  key: 1,
  class: "false"
};
const _hoisted_46 = {
  key: 0,
  class: "tips"
};
const _hoisted_47 = {
  key: 1,
  class: "tips"
};
const _hoisted_48 = {
  class: "tips"
};
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "false"
}, "众筹还未开始", -1));
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "tips tips-no-time"
}, "待发起人设定众筹上线时间", -1));
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "false"
}, "众筹还未开始", -1));
const _hoisted_52 = {
  key: 5,
  class: "false"
};
const _hoisted_53 = {
  key: 7,
  class: "false"
};
const _hoisted_54 = {
  key: 8,
  class: "false"
};
const _hoisted_55 = {
  class: "related-reward-popup"
};
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "下单失败", -1));
const _hoisted_57 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, "需先购买关联的必买档位，才有资格购买此档位", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CompPopupBottom = _resolveComponent("CompPopupBottom");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_CompPopupBottom, {
    show: $props.show,
    type: "reward",
    onOpen: $options.opened
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("i", {
      class: "close",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.closePopup && $options.closePopup(...args))
    })]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
      class: _normalizeClass(['info-top', {
        'info-top-false': $options.cannotChose($data.reword_item)
      }]),
      ref: "infoTop",
      onScroll: _cache[2] || (_cache[2] = (...args) => $options.infoTopScroll && $options.infoTopScroll(...args))
    }, [_createElementVNode("div", _hoisted_5, [$data.reword_item.id != -3 ? (_openBlock(), _createElementBlock("strong", _hoisted_6, "￥" + _toDisplayString($data.reword_item.money), 1)) : _createCommentVNode("", true), $data.reword_item.back_count ? (_openBlock(), _createElementBlock("span", _hoisted_7, "已支持" + _toDisplayString($data.reword_item.back_count) + "份", 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_8, [$data.reword_item.is_customized > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, "定制类产品")) : _createCommentVNode("", true), $data.reword_item.app_money > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_10, "摩点App仅需 ¥" + _toDisplayString($data.reword_item.app_money), 1)) : _createCommentVNode("", true), $data.reword_item.rush_time && ($data.reword_item.status == 100 || $data.reword_item.status == 101) ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString($data.reword_item.rush_time), 1)) : _createCommentVNode("", true), $data.reword_item.status == 200 && $data.reword_item.end_type == 1 && $data.reword_item.remaining_time && $data.remainingTime ? (_openBlock(), _createElementBlock("div", _hoisted_12, " 限时距结束 " + _toDisplayString($data.remainingTime), 1)) : _createCommentVNode("", true), ($data.reword_item.status == 300 || $data.reword_item.status == 301) && _ctx.end_type == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_13, "已截止 ")) : _createCommentVNode("", true), $data.reword_item.num > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, "限 " + _toDisplayString($data.reword_item.num) + "份", 1)) : _createCommentVNode("", true), $data.reword_item.vip_discount_money > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_15, [$data.reword_item.vip_discount_num > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createTextVNode(" 商家老客户下单立减 " + _toDisplayString($data.reword_item.vip_discount_money) + "元，限" + _toDisplayString($data.reword_item.vip_discount_num) + "份 ", 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createTextVNode(" 商家老客户下单立减 " + _toDisplayString($data.reword_item.vip_discount_money) + "元 ", 1)], 64))])) : _createCommentVNode("", true), $data.reword_item.limit_per_user > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_16, "每人限购 " + _toDisplayString($data.reword_item.limit_per_user) + "份", 1)) : _createCommentVNode("", true), $data.reword_item.idea_favor_discount > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_17, [$data.reword_item.idea_favor_discount_num > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createTextVNode(" 创意期看好立减 " + _toDisplayString($data.reword_item.idea_favor_discount) + "元，限" + _toDisplayString($data.reword_item.idea_favor_discount_num) + "份 ", 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createTextVNode(" 创意期看好立减 " + _toDisplayString($data.reword_item.idea_favor_discount) + "元 ", 1)], 64))])) : _createCommentVNode("", true), $data.reword_item.is_favor_idea_reward == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_18, " 创意看好专享档 ")) : _createCommentVNode("", true), $data.reword_item.is_related_reward == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_22)) : _createCommentVNode("", true)]), $data.reword_item.is_related_reward == 1 ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(['related-reward', {
        'related-reward-up': !$data.shwoIcondown
      }]),
      onClick: _cache[1] || (_cache[1] = $event => $data.shwoIcondown = !$data.shwoIcondown)
    }, [_createElementVNode("div", _hoisted_23, _toDisplayString($data.reword_item.related_reward_desc), 1), $data.showIcon ? (_openBlock(), _createElementBlock("i", _hoisted_24)) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_25, [_createElementVNode("strong", null, _toDisplayString($data.reword_item.name), 1), $data.reword_item.reward_day ? (_openBlock(), _createElementBlock("span", _hoisted_26, "（预计发放时间 " + _toDisplayString($data.reword_item.reward_day) + "）", 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_27, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.reword_item.rew_logo, (item, index) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [index < 3 ? (_openBlock(), _createElementBlock("img", {
        key: index,
        src: `${_ctx.$imgUrlFilter(item, 170, 170)}`
      }, null, 8, _hoisted_28)) : _createCommentVNode("", true)], 64);
    }), 256))]), _createElementVNode("div", {
      class: "des",
      innerHTML: $options.dealContent($data.reword_item.content)
    }, null, 8, _hoisted_29), $data.reword_item.is_customized ? (_openBlock(), _createElementBlock("div", _hoisted_30, "*该产品为定制产品，众筹成功后不支持无理由退货退款")) : _createCommentVNode("", true), $data.reword_item.online_unpack_type > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_31, " *盲盒类商品具有随机性，付款后即在线拆盒显示具体款项，不支持退货退款")) : _createCommentVNode("", true), $data.reword_item.reward_pack_desc && $data.reword_item.reward_pack_desc.length ? (_openBlock(true), _createElementBlock(_Fragment, {
      key: 3
    }, _renderList($data.reword_item.reward_pack_desc, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "reward_pack_desc",
        key: index
      }, _toDisplayString(item), 1);
    }), 128)) : _createCommentVNode("", true)], 34), $data.show_info_top_bg ? (_openBlock(), _createElementBlock("div", _hoisted_32)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_33, [_hoisted_34, _createElementVNode("span", null, "共" + _toDisplayString($data.reward_list.length) + "个", 1)]), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", {
      class: "reward-list",
      ref: "rewardList",
      onScroll: _cache[3] || (_cache[3] = (...args) => $options.rewordScroll && $options.rewordScroll(...args))
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.reward_list, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['reward-item-box', {
          'reward-item-box-checked': !$options.cannotChose($data.reword_item) && $props.reward_id ? $props.reward_id == item.id : $data.chooseIndex == index
        }]),
        key: index
      }, [_createElementVNode("div", {
        class: _normalizeClass(['reward-item', {
          'reward-item-false': $options.cannotChose(item)
        }]),
        onClick: $event => $options.checkRewardItem(index, item)
      }, [_createElementVNode("span", null, _toDisplayString(item.name), 1), item.draw_card_id ? (_openBlock(), _createElementBlock("i", _hoisted_37, "抽卡机")) : _createCommentVNode("", true), item.num > 0 ? (_openBlock(), _createElementBlock("i", _hoisted_38, "限量")) : _createCommentVNode("", true), item.end_type == 1 || item.rush_time > 0 ? (_openBlock(), _createElementBlock("i", _hoisted_39, "限时")) : _createCommentVNode("", true), item.online_unpack_type > 0 ? (_openBlock(), _createElementBlock("i", _hoisted_40, "在线拆盒")) : _createCommentVNode("", true), item.is_related_reward == 1 ? (_openBlock(), _createElementBlock("i", _hoisted_41, "加购")) : _createCommentVNode("", true), !$options.cannotChose($data.reword_item) && $data.chooseIndex == index ? (_openBlock(), _createElementBlock("img", _hoisted_42)) : _createCommentVNode("", true)], 10, _hoisted_36)], 2);
    }), 128))], 544), $data.show_reword_list_bg ? (_openBlock(), _createElementBlock("div", _hoisted_43)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_44, [$options.projectState == 'luckycards' ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      onClick: _cache[4] || (_cache[4] = (...args) => $options.goLuckycards && $options.goLuckycards(...args))
    }, "立即去抽卡")) : $data.reword_item.is_purchase_forbidden == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_45, "无购买权限")) : $options.projectState == 11 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 2
    }, [$data.reword_item.toast ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString($data.reword_item.toast), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_47, "还剩 " + _toDisplayString($data.onlineRemainingTime) + " 开始", 1)), _createElementVNode("div", {
      onClick: _cache[5] || (_cache[5] = (...args) => $options.refreshRewardsItem && $options.refreshRewardsItem(...args))
    }, "点击刷新")], 64)) : $options.projectState == 12 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 3
    }, [_createElementVNode("span", _hoisted_48, _toDisplayString($data.reword_item.online_time) + " 开始", 1), _hoisted_49], 64)) : $options.projectState == 13 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 4
    }, [_hoisted_50, _hoisted_51], 64)) : $options.projectState == 21 ? (_openBlock(), _createElementBlock("div", _hoisted_52, "已抢光")) : $options.projectState == 22 ? (_openBlock(), _createElementBlock("div", {
      key: 6,
      onClick: _cache[6] || (_cache[6] = (...args) => $options.goPay && $options.goPay(...args))
    }, "立即购买支持")) : $options.projectState == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_53, "已截止")) : $options.projectState == 4 ? (_openBlock(), _createElementBlock("div", _hoisted_54, "众筹已结束")) : _createCommentVNode("", true)])])])]),
    _: 1
  }, 8, ["show", "onOpen"]), _createVNode(_component_van_popup, {
    show: $data.showRelatedReward,
    "onUpdate:show": _cache[8] || (_cache[8] = $event => $data.showRelatedReward = $event),
    teleport: "body",
    round: "",
    "close-on-click-overlay": false
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_55, [_hoisted_56, _hoisted_57, _createElementVNode("div", {
      class: "btn",
      onClick: _cache[7] || (_cache[7] = $event => $data.showRelatedReward = false)
    }, "好的")])]),
    _: 1
  }, 8, ["show"])]);
}